class SSE {

    constructor() {
        this.sse = null;
        this.callbacks = {};
    }

    setConfig(url, token) {
        //console.log(url, token);
        this.url = url;
        this.token = token;
    }

    async connect() {
        this.sse = new EventSource(this.url + "/events/register?auth=" + this.token);
        this.sse.onerror = () => {
            //console.warn('SSE connection error, closing');
            this.sse?.close();
        };
    }

    disconnect() {
        this.sse?.close()
    }

    addListener(eventName, cb) {
        this.callbacks[eventName] = function(e) {
            cb(JSON.parse(e.data));
        }
        this.sse.addEventListener(eventName, this.callbacks[eventName]);
    }

    removeListener(eventName, cb) {
        this.sse.removeEventListener(eventName, this.callbacks[eventName]);
        delete this.callbacks[eventName];
    }

    async reconnect(token) {
        this.disconnect();
        this.token = token;
        await this.connect();
        //console.log('REGISTER CB', Object.keys(this.callbacks));
        Object.keys(this.callbacks).forEach((eventName) => {
            this.sse.addEventListener(eventName, this.callbacks[eventName]);
        });
    }
}

const sse = new SSE();
export default sse;

window.sse = sse;